import { __spreadArray } from 'tslib';
import React__default from 'react';
import { useTheme, TableCell, TableRow, Skeleton } from '@mui/material';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../providers/locale/hooks.js';
import { useCurrentUser } from '../../../providers/users/hooks.js';
import StyledKTableContainer, { classes } from './index.styled.js';
import { renderTitleCell, renderCreationCell, renderStateCell, renderTemplateCell, renderShareUrlCell, renderActionsCell } from './utils.js';

var KTableContainer = function KTableContainer(_a) {
    var totalCount = _a.totalCount, rows = _a.rows, onPageSizeChange = _a.onPageSizeChange, onPageNumberChange = _a.onPageNumberChange, onDeleteShareToken = _a.onDeleteShareToken, onEditShareToken = _a.onEditShareToken, pageSize = _a.pageSize, pageNumber = _a.pageNumber, loading = _a.loading, className = _a.className, _b = _a.testId, testId = _b === void 0 ? "KTableContainer" : _b, sx = _a.sx, KIcon = _a.KIcon;
    var dataLocale = useLocale().dataLocale;
    var t = useTranslation("refront-components").t;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var theme = useTheme();
    var currentUser = useCurrentUser().currentUser;
    var columnsData = [
        {
            columnName: t("components.kf-general-public-sharing.table.header.cell.title"),
            columnWidth: "15%",
            className: classes.ellipsisCell,
            columnRender: function (row) { return renderTitleCell(row); }
        },
        {
            columnName: t("components.kf-general-public-sharing.table.header.cell.creation"),
            columnRender: function (row, t) { return renderCreationCell(row, t); }
        },
        {
            columnName: t("components.kf-general-public-sharing.table.header.cell.state"),
            columnRender: function (row, t, theme) { return renderStateCell(row, theme, t); }
        },
        {
            columnName: t("components.kf-general-public-sharing.table.header.cell.template"),
            className: classes.ellipsisCell,
            columnRender: function (row, _t, _theme, dataLocale) { return renderTemplateCell(row, dataLocale); }
        },
        {
            columnName: t("components.kf-general-public-sharing.table.header.cell.link"),
            columnWidth: "35%",
            className: classes.ellipsisCell,
            columnRender: function (row, t, _theme, _dataLocale, enqueueSnackbar) {
                return renderShareUrlCell(row, enqueueSnackbar, t, KIcon);
            }
        },
        {
            columnName: t("components.kf-general-public-sharing.table.header.cell.actions"),
            columnWidth: "130px",
            className: classes.ellipsisCell,
            headerClassName: classes.actionCell,
            columnRender: function (row, t) {
                return (onDeleteShareToken &&
                    onEditShareToken &&
                    renderActionsCell(row, t, onDeleteShareToken, onEditShareToken, currentUser, KIcon)) ||
                    null;
            }
        },
    ];
    return (React__default.createElement(StyledKTableContainer, { className: clsx("KTableContainer", className), "data-testid": testId, columnsComponent: columnsData.map(function (columnData) { return (React__default.createElement(TableCell, { key: columnData.columnName, className: columnData.headerClassName, width: columnData.columnWidth }, columnData.columnName)); }), loading: loading, loadingComponent: __spreadArray([], Array(1), true).map(function (_value, index) { return (React__default.createElement(TableRow, { key: index },
            React__default.createElement(TableCell, { colSpan: columnsData.length, align: "center" },
                React__default.createElement(Skeleton, { animation: "wave" })))); }), pageSize: pageSize, pageNumber: pageNumber, onPageSizeChange: onPageSizeChange, onPageNumberChange: onPageNumberChange, totalCount: totalCount, noResultComponent: React__default.createElement(TableRow, null,
            React__default.createElement(TableCell, { colSpan: columnsData.length, align: "center" }, t("components.kf-general-public-sharing.table.body.cell.no-result"))), sx: sx }, rows &&
        rows.map(function (row) { return (React__default.createElement(TableRow, { key: row.tokenValue }, columnsData.map(function (columnData) { return (React__default.createElement(TableCell, { key: "column-data-".concat(columnData.columnName), className: columnData.className }, columnData.columnRender(row, t, theme, dataLocale, enqueueSnackbar))); }))); })));
};

export { KTableContainer as default };
//# sourceMappingURL=index.js.map
